var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useId } from '../hooks';
import { Text } from '../text';
import { categoryDividerStaticStyle, categoryLabelStaticStyle } from './styles';
function Category(_a) {
    var { children, label, noDivider = false } = _a, restProps = __rest(_a, ["children", "label", "noDivider"]);
    const categoryId = `dropdown-category-${useId()}`;
    const hasLabel = label != null;
    return (_jsxs("div", Object.assign({}, restProps, { role: "group" }, (hasLabel && { 'aria-labelledby': categoryId }), { children: [!noDivider && _jsx("div", { css: categoryDividerStaticStyle }), hasLabel && (_jsx(Text, Object.assign({ as: "p", css: categoryLabelStaticStyle, id: categoryId }, { children: label }))), children] })));
}
export default Category;
